var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"map",attrs:{"id":"map"}},[_c('span',{staticClass:"alert alert-warning mt-5"},[_vm._v("No location data")])])
}
var staticRenderFns = []

export { render, staticRenderFns }